module.exports = __webpack_public_path__ + "img/clipper22.d3731a09.png";